import { createConsumer } from "@rails/actioncable";

// This action cable url comes from the <%= action_cable_meta_tag %> in the onsite layout
export default createConsumer("/cable?client_id=onsite_app");
